// extracted by mini-css-extract-plugin
module.exports = {"selected":"SelectButtons_fasting_selected__15iJd"};